module.exports = __webpack_public_path__ + "img/back_white.27cbc0ef.svg";